module.exports = __webpack_public_path__ + "img/Girl&Gun-01.jpg";